import React, { useState } from "react";
import "./SapAbap.css";
import DownloadForm from "../DownloadForm/DownloadForm";

const SapProcurementInventory = () => {
  const [showForm, setShowForm] = useState(false);

  const handleDownloadClick = () => {
    setShowForm(true);
  };

  const handleCloseForm = () => {
    setShowForm(false);
  };

  return (
    <div className="sapfincon-wrapper">
      <div className="background-animation">
        <div className="floating-circle"></div>
        <div className="floating-circle"></div>
        <div className="floating-circle"></div>
        <div className="floating-circle"></div>
        <div className="floating-circle"></div>
        <div className="floating-circle"></div>
      </div>

      <div
        className="jumbotron jumbotron-fluid page-header position-relative overlay-bottom"
        style={{ marginBottom: "90px" }}
      >
        <div className="container text-center py-5" style={{ marginTop: "-80px" }}>
          <h1 className="text-white display-1">Material Management</h1>
          <div className="d-inline-flex text-white mb-5">
            <p className="m-0 text-uppercase">
              <a className="text-white" href="">Home</a>
            </p>
            <i className="fa fa-angle-double-right pt-1 px-3"></i>
            <p className="m-0 text-uppercase">SAP</p>
          </div>
        </div>
      </div>

      <div className="sapfincon-flexbox">
        <div className="sapfincon-left">
          <div className="sapfincon-wrapper zoom-effect">
            <img
              src="/assets/img/sapfince.jpg"
              alt="SAP Banner"
              className="sapfincon-main-image"
            />
          </div>
        </div>
        <div className="sapfincon-right">
          <h2 className="sapfincon-title">Accelerate Your Career with BDM Technology’s In-Demand SAP MM Program</h2>
          <p className="sapfincon-description">
            Master the art of supply chain and procurement with SAP S/4 HANA Material Management – a vital module in enterprise resource planning that drives efficiency, transparency, and cost savings in materials and inventory management.
          </p>
          <ul className="sapfincon-list">
            {[
              "Industry-Relevant Skillset – Essential for procurement and inventory operations.",
              "Streamlined Supply Chain – Improve procurement, warehousing, and logistics.",
              "Real-Time Inventory Tracking – Accurate monitoring and decision-making.",
              "Cost Optimization – Reduces excess inventory and improves vendor negotiations.",
              "Integration with Other Modules – Seamlessly works with SAP SD, FICO, and PP.",
              "Career Advancement – Open roles in procurement, logistics, ERP consulting.",
            ].map((text, idx) => (
              <li className="sapfincon-list-item" key={idx}>
                <span className="sapfincon-icon">
                  <svg
                    aria-hidden="true"
                    viewBox="0 0 512 512"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998
                       26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997
                       26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206
                       0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"/>
                  </svg>
                </span>
                <span className="sapfincon-text">{text}</span>
              </li>
            ))}
          </ul>
          <p className="sapfincon-careers">SAP MM Consultant, Procurement Specialist, Inventory Analyst</p>
        </div>
      </div>

      <div className="sapfincon-content-section">
        <div className="container">

          <div className="upgrade-section">
            <h2 className="section-title">
              <strong>Upgrade your coding skills with BDM Technology’s Expert-Led SAP MM Course!</strong>
            </h2>
            <p className="section-description">
              SAP MM is the core of material and inventory management in ERP. Gain hands-on skills to streamline procurement, optimize inventory, and enhance supply chain visibility.
            </p>
          </div>

          <div className="why-study-section">
            <h3 className="subsection-title"><strong>Why Study SAP Material Management (MM)?</strong></h3>
            <p className="subsection-description">
              SAP MM is an integral part of logistics that helps businesses streamline their procurement processes, manage vendors, and control inventory effectively. With digital supply chains evolving, SAP MM professionals are in high demand across industries.
            </p>
          </div>

          <div className="benefits-section">
            <h3 className="subsection-title"><strong>Benefits of Learning SAP MM</strong></h3>
            <ul className="benefits-list">
              <li><strong>Industry-Relevant Skillset</strong> – Essential for procurement and inventory operations.</li>
              <li><strong>Streamlined Supply Chain</strong> – Improve procurement, warehousing, and logistics.</li>
              <li><strong>Real-Time Inventory Tracking</strong> – Accurate monitoring and decision-making.</li>
              <li><strong>Cost Optimization</strong> – Reduces excess inventory and improves vendor negotiations.</li>
              <li><strong>Integration with Other Modules</strong> – Seamlessly works with SAP SD, FICO, and PP.</li>
              <li><strong>Career Advancement</strong> – Open roles in procurement, logistics, ERP consulting.</li>
            </ul>
          </div>

          <div className="future-scope-section">
            <h3 className="subsection-title"><strong>Future Scope of SAP MM</strong></h3>
            <ul className="scope-list">
              <li><strong>Expanding Digital Supply Chains</strong> – Increasing reliance on ERP-based material management.</li>
              <li><strong>e-Procurement Growth</strong> – Rise in electronic purchasing processes across industries.</li>
              <li><strong>Data-Driven Inventory Optimization</strong> – Predictive analytics driving stock control.</li>
              <li><strong>Cross-Sector Adoption</strong> – Retail, manufacturing, pharmaceuticals, automotive, and more.</li>
              <li><strong>Consulting Opportunities</strong> – High demand for SAP MM consultants and logistics planners.</li>
              <li><strong>Continuous Product Enhancements</strong> – SAP’s evolving platform ensures long-term relevance.</li>
            </ul>
          </div>

          <div className="key-features-section">
            <h3 className="subsection-title"><strong>Key Features of BDM Technology</strong></h3>
            <div className="features-grid">
              <div className="feature-item">
                <h4>100% Job-Oriented Training</h4>
                <p>Curriculum tailored to industry requirements, ensuring you gain the skills employers are looking for.</p>
              </div>
              <div className="feature-item">
                <h4>Industry Expert Faculties</h4>
                <p>Learn from seasoned professionals with real-world experience.</p>
              </div>
              <div className="feature-item">
                <h4>Flexible Demo Class Available</h4>
                <p>Opportunity to attend a demo session and experience the training style before enrolling.</p>
              </div>
              <div className="feature-item">
                <h4>Completed 400+ Batches</h4>
                <p>Proven track record with hundreds of successful batches, demonstrating program reliability and effectiveness.</p>
              </div>
              <div className="feature-item">
                <h4>Certification Guidance</h4>
                <p>Support throughout your journey to help you earn relevant certifications that boost your career.</p>
              </div>
              <div className="feature-item">
                <h4>Live Practical Sessions</h4>
                <p>Hands-on, interactive sessions to reinforce learning and apply concepts in real-time.</p>
              </div>
              <div className="feature-item">
                <h4>Peaceful Environment</h4>
                <p>A conducive learning atmosphere that helps you focus and maximize your learning potential.</p>
              </div>
            </div>
          </div>

          <div className="who-attend-section">
            <h3 className="subsection-title"><strong>Who Should Enroll</strong></h3>
            <ul className="attend-list">
              <li>Aspiring SAP MM Consultants</li>
              <li>Graduates in supply chain, logistics, operations, or business management</li>
              <li>Procurement professionals looking to upgrade with ERP expertise</li>
              <li>Working professionals seeking a career shift to ERP/SAP domain</li>
            </ul>
          </div>

          <div className="hiring-companies-section">
            <h3 className="subsection-title"><strong>Hiring Companies</strong></h3>
            <div className="companies-grid">
              {[
                { logo: "/assets/img/Cognizant.png" },
                { logo: "/assets/img/tcs.jpg" },
                { logo: "/assets/img/infoysis.jpg" },
                { logo: "/assets/img/ibm.png" },
                { logo: "/assets/img/hcl.png" },
                { logo: "/assets/img/Accenture.png" },
                { logo: "/assets/img/capgemini.png" },
                { logo: "/assets/img/Deloitte.png" },
                { logo: "/assets/img/nttdata.png" },
                { logo: "/assets/img/wipro.png" },
                { logo: "/assets/img/KaarTech.png" },
                { logo: "/assets/img/lt.png" },
                { logo: "/assets/img/Siemens.png" },
                { logo: "/assets/img/techmahindra.png" },
              ].map((company, index) => (
                <div className="company-card" key={index}>
                  <img
                    src={company.logo}
                    alt={company.name}
                    className="company-logo"
                  />
                  <span className="company-name">{company.name}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="salary-overview-section">
            <h3 className="subsection-title"><strong>Salary Overview</strong></h3>
            <div className="salary-grid">
              <div className="salary-item">
                <h4>Entry-Level (0–2 Years)</h4>
                <p className="salary-amount">₹4.5 – ₹7 LPA</p>
              </div>
              <div className="salary-item">
                <h4>Mid-Level (2–5 Years)</h4>
                <p className="salary-amount">₹7 – ₹12 LPA</p>
              </div>
              <div className="salary-item">
                <h4>Senior-Level (5+ Years)</h4>
                <p className="salary-amount">₹12 – ₹20+ LPA</p>
              </div>
              <div className="salary-item">
                <h4>SAP MM Solution Architects & SCM Leads</h4>
                <p className="salary-amount">₹22 – ₹30+ LPA</p>
              </div>
            </div>
          </div>

          <div className="download-section">
            <h3 className="download-heading">
              Want to know more? <br />
              <span>Please download the course PDF.</span>
            </h3>
            <button className="download-button" onClick={handleDownloadClick}>
              📄 Download Course PDF
            </button>
          </div>

          {showForm && (
            <DownloadForm
              onClose={handleCloseForm}
              courseName="SAP MM"
              pdfUrl="/uploads/pdfs/05.pdf"
            />
          )}
        </div>
      </div>

      
    </div>
  );
};

export default SapProcurementInventory;